export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"version","content":"24.8.0"},{"name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#50FCEA"}],"link":[{"rel":"icon","type":"image/png","href":"/sc/favicon.png"},{"rel":"dns-prefetch","href":"https://consent.cookiefirst.com"},{"rel":"dns-prefetch","href":"https://edge.cookiefirst.com"},{"rel":"preload","type":"font/woff2","href":"/sc/fonts/source-sans-pro_regular-latin.woff2","as":"font","crossorigin":""},{"rel":"preload","type":"font/woff2","href":"/sc/fonts/source-sans-pro_bold-latin.woff2","as":"font","crossorigin":""}],"style":[],"script":[{"innerHTML":"\n(function (w, d, s, l, i) {\n    w[l] = w[l] || [];\n    w[l].push({\n        \"gtm.start\": new Date().getTime(), event: 'gtm.js',\n        \"gtm.consent\" : {\n          default: {\n            'ad_storage': 'denied',\n            'analytics_storage': 'denied',\n            'wait_for_update': 1500 //milliseconds\n          }\n        },\n        \"gtm.set\": {ads_data_redaction: true}\n    });\n    var f = d.getElementsByTagName(s)[0],\n        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';\n    j.async = true;\n    j.src =\n        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;\n    j.addEventListener('load', function() {\n      function getCookie(cookieName) {\n        let cookie = {};\n        document.cookie.split(';').forEach(function(el) {\n          let [key,value] = el.split('=');\n          cookie[key.trim()] = value;\n        })\n        return cookie[cookieName];\n      }\n      let ref = getCookie('CakeCookie[ref]');\n      if (!ref) {\n        ref = (new URLSearchParams(window.location.search)).get('ref');\n      }\n      if (ref) {\n        window.dataLayer = window.dataLayer || [];\n        if (!window.gtag) { function gtag(){dataLayer.push(arguments);} }\n        gtag('set', { 'campaign_source': ref, 'campaign_medium': 'affiliate'});\n      }\n    });\n    f.parentNode.insertBefore(j, f);\n  })(window, document, 'script', 'dataLayer', 'GTM-N4BG36H');\n","type":"text/javascript"},{"innerHTML":"\n  window.varify = window.varify || {};\n  window.varify.iid = 2710;\n","type":"text/javascript"},{"src":"https://app.varify.io/varify.js"}],"noscript":[],"title":"GPORTAL"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false